import { createTheme } from '../utils';
import * as Modal from './components/Modal.css';

export const defaultTheme = {
	Modal
};

export default defaultTheme;

export const { useTheme, Provider } = createTheme<typeof defaultTheme>(defaultTheme);
